import { useStore } from "@stores"

export const indexOperation = "backstage/IndexMyFiles"


const useDocumentsStore = (request, shouldAutoLoad = true) => {
  const {
    items: documents,
    indexItems: indexDocuments
  } = useStore(indexOperation, request, shouldAutoLoad)

  return {
    documents,
    indexDocuments,
  }
}

export default useDocumentsStore
